module.exports = __webpack_public_path__ + "img/bg.99d39cc7.png";